/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {ListGroup, Card, Row , Col, Button,Modal} from 'react-bootstrap'
import 'react-multiselect-box/build/css/index.css'
import Translation from '../store/internationalization-store.js'
import {ProductService, AccountService} from '../services';
import {ProductStore, AccountStore} from '../store';
import Constants from '../constants.js';
import Alert from './alert.js';
import Checkbox from './checkbox.js';
import LanguageSelect from './language_select.js';
import Popup from './popup/comfirmation_popup.js'
import Package from '../classes/package.js';

export default class UpdateCurriculumSettings extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        if (this.props.classUid != undefined) {
            this.state ={
                isClass:true,
                classUid: this.props.classUid,
                totalCurriculumOptions: []
            }
        } else {
            this.state ={
                isClass:false,
                totalCurriculumOptions: []
            }
        }
    }

    componentWillMount(){
        AccountService.getInformation();
        AccountStore.on(Constants.GET_ACCOUNT , ()=>{

            var enableExamTranscripts = 
                    (AccountStore.get().accountSettings != undefined &&
                    AccountStore.get().accountSettings['enableExamTranscripts'] != undefined &&
                    AccountStore.get().accountSettings['enableExamTranscripts'] == "1")
            var enableExamSpeech = 
                    (AccountStore.get().accountSettings != undefined &&
                    AccountStore.get().accountSettings['enableExamSpeech'] != undefined &&
                    AccountStore.get().accountSettings['enableExamSpeech'] == "1")
            var showSchoolRanking = 
                    (AccountStore.get().accountSettings != undefined &&
                    AccountStore.get().accountSettings['showSchoolRanking'] != undefined &&
                    AccountStore.get().accountSettings['showSchoolRanking'] == "1")
            var hints = 
                    (AccountStore.get().accountSettings != undefined &&
                    AccountStore.get().accountSettings['hints'] != undefined &&
                    AccountStore.get().accountSettings['hints'] == "1")
            var individualPercentage = "40";
            var totalPercentage = "50";
            if (AccountStore.get().accountSettings != undefined) {
                if (AccountStore.get().accountSettings['individualPercentage'] != undefined) {
                    individualPercentage = AccountStore.get().accountSettings['individualPercentage'];
                }
                if (AccountStore.get().accountSettings['totalPercentage'] != undefined) {
                    totalPercentage = AccountStore.get().accountSettings['totalPercentage'];
                }
            }

            var cefrHasNoDrop = (
				AccountStore.get().accountSettings != undefined &&
                AccountStore.get().accountSettings['cefrHasNoDrop'] != undefined &&
                AccountStore.get().accountSettings['cefrHasNoDrop'] == "1"
			);
            
            this.setState({
                loaded:true,
                "disableHints":hints,
                "enableExamTranscripts":enableExamTranscripts,
                "showSchoolRanking":showSchoolRanking,
                "individualPercentage":individualPercentage,
                "totalPercentage":totalPercentage,
                "enableExamSpeech":enableExamSpeech,
                "cefrHasNoDrop": cefrHasNoDrop
            });
        })

        ProductStore.on(Constants.GET_SHARED_CURRICULUM,  ()=>{
                var additionalCurriculums = ProductStore.getSharedAdditionalCurriculums();
                var languages = [];
                var actualLanguges = [];
                var list = [];
                
                for(var i = 0 ; i < additionalCurriculums.length; i++) {
                    if (this.language == undefined) {
                        this.language = additionalCurriculums[i].ietf
                    }
                    if (languages.indexOf(additionalCurriculums[i].ietf) == -1) {
                        languages.push(additionalCurriculums[i].ietf);
                        actualLanguges.push({value:additionalCurriculums[i].ietf});
                    }
                    list.push({value:String(additionalCurriculums[i].curriculumUid),
                        label:additionalCurriculums[i].name, 
                        ietf:additionalCurriculums[i].ietf, 
                        languageTitle:additionalCurriculums[i].languageName, 
                        isSelected:additionalCurriculums[i].isSelected == true,
                        information:additionalCurriculums[i].information})
                }

                this.setState({
                    totalCurriculumOptions:list,
                    languageLimiter:actualLanguges
                })

        });
    }

    componentDidMount(){
        ProductService.getAllLanguages();
        ProductService.getSharedAdditionalCurriculums();
    }

    componentWillReceiveProps(props) {
        if (this.props.classUid != props.classUid) {
            ProductService.getSharedAdditionalCurriculums();
            this.setState({
                isClass:false,
                totalCurriculumOptions: []
            })
        }
    }

    save() {
        var finalList = [];
        for (var i = 0; i < this.state.totalCurriculumOptions.length;i++) {
            if(this.state.totalCurriculumOptions[i].isSelected == true) {
                finalList.push(this.state.totalCurriculumOptions[i]); 
            }
        }
        if (this.state.classUid != undefined) {
            ProductService.setAccountCurriculumsClass(finalList,this.state.classUid).then(function(){
                this.setState({saved:true})
                if (this.props.onSave != undefined) {
                    this.props.onSave();
                }
            }.bind(this));
        } else {
            ProductService.setAccountCurriculums(finalList).then(function(){
                this.setState({saved:true, updated:false})
                if (this.props.onSave != undefined) {
                    this.props.onSave();
                }
            }.bind(this));
        }

        var columStuff = {
            settings_hints:this.state.disableHints ? "1" : "0",
            settings_enableExamTranscripts:this.state.enableExamTranscripts ? "1" : "0",
            settings_enableExamSpeech:this.state.enableExamSpeech ? "1" : "0",
            settings_showSchoolRanking:this.state.showSchoolRanking ? "1" : "0"
        }
        var isAccount = true;

        if (isAccount = true) {
            columStuff = {
                settings_hints:this.state.disableHints ? "1" : "0",
                settings_enableExamTranscripts:this.state.enableExamTranscripts ? "1" : "0",
                settings_showSchoolRanking:this.state.showSchoolRanking ? "1" : "0",
                settings_individualPercentage:this.state.individualPercentage,
                settings_totalPercentage:this.state.totalPercentage,
                settings_enableExamSpeech:this.state.enableExamSpeech ? "1" : "0"
            }
        }

        AccountService.update(columStuff).then(function(){
            this.setState({
                saved:true,
                updated:false,
                baseEmail:this.state.email,
            });
        }.bind(this))
    }

    saveOnlyCEFR() {
        AccountService.update({
            settings_cefrHasNoDrop:this.state.cefrHasNoDrop ? "1" : "0"
        });
    }



    getVocabList(data, isFirst) {
        var firstStyle = "0px 1px 1px 1px"
        if (isFirst) {
            firstStyle = "1px 1px 1px 1px"
        }
        var i = "";
        if (this.state.classUid == undefined) {
            i = <span style={{paddingRight:"5px"}}>
                <i onClick={()=>{
                    this.setState({information:true, infoData:data.information, infoDataTitle:data.label})}
                    } class="fas fa-info-circle"></i>
            </span>
        }
        return  <div style={{border:"rgb(0, 0, 0)", borderWidth:firstStyle, 
                borderStyle:"solid", padding:"10px"}}>
            <Row > 
                <Col sm={{span: 10, offset: 0}}><Card.Text>{i}
                    <span onClick={function() {
                            data.isSelected = !data.isSelected
                            this.setState({updated:true, saved:false})
                        }.bind(this)}>{data.label}</span>
                </Card.Text></Col>
                <Col sm={{span: 2, offset: 0}}><span className="float-right" onClick={function() {
                        data.isSelected = !data.isSelected
                        this.setState({updated:true, saved:false})
                    }.bind(this)}>
                        <Checkbox isDisabled checked={data.isSelected}/></span>
                </Col>
            </Row>
        </div>
    }

    generateSelectableOptions() {
        var languagesData = [];
        var data = this.state.totalCurriculumOptions;
        for (var i = 0; i < data.length; i++) {
            if (languagesData[data[i].ietf] == undefined) {
                languagesData[data[i].ietf] = [data[i].languageTitle, [<hr></hr>]]
            }
            languagesData[data[i].ietf][1].push(this.getVocabList(data[i], languagesData[data[i].ietf][1].length == 1))
        }
        return languagesData;
    }

    setLanguageValue(language){
        this.language = language.ietf;
        this.setState({updated:false})
    }

    getUserName() {
        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined 
            || ProductStore.userData.accountSettings['cefrAdminUsername'] == undefined) {
            return "N/A";
        }
        return ProductStore.userData.accountSettings['cefrAdminUsername'];
    }

    getPassword() {
        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined 
            || ProductStore.userData.accountSettings['cefrAdminPassword'] == undefined) {
            return "N/A";
        }
        return ProductStore.userData.accountSettings['cefrAdminPassword'];
    }

    render(){
        if (this.state.totalCurriculumOptions == undefined) {
            return "";
        }
        var adminData = "";
        if (ProductStore.userData != undefined) {
            var password = this.getPassword();
            var username = this.getUserName();

            if (password != ""){
                adminData =<Card body>
                        <Row md={12}>
                            <Col md={12}><b>Admin login:</b></Col>
                            <Col md={12}>Username: {username}</Col><Col md={12}>Password: {password}</Col>
                        </Row>
                    </Card>
            }
        }
        
        var generateOptions = this.generateSelectableOptions();
        let saved = null;
        var finalData = ""
        if (generateOptions[this.language] != undefined) {
            finalData = generateOptions[this.language][1];
        }

        var popup = <Popup title={this.state.infoDataTitle} oneButton={true} onSave={()=>{ this.setState({information:false});}} 
                onHide={()=>{this.setState({information:false})}} show={this.state.information} 
                body={this.state.infoData} />

        if (this.state.classUid != undefined) {
            return [<Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Alert variant="success">
                                {Translation.get(12685 , 'This content has been created by the Languagenut Teacher community and validated by the Languagenut team. To give your students access to this content please tick below.')}
                            </Alert>
                        </Col>
                    </Row>
                    <Row>
                    <Col md={12}>{saved}</Col>
                    </Row>
                    <Row>
                        <Col md={4}><LanguageSelect limitLanguages={this.state.languageLimiter} returnValue={this.setLanguageValue.bind(this)} title={<b>{Translation.get(12684, 'Select a language')}</b>}/></Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <ListGroup>
                            {finalData}
                            </ListGroup>
                        </Col>
                    </Row>
                    <br></br>
                </Modal.Body>,
                <Modal.Footer>
                    <Row>
                        <Col md={{span:6 , offset:6}}>
                            <Button disabled={true} onClick={this.save.bind(this)}  className="float-right">{Translation.get(12658 ,'Update')}</Button>
                        </Col>
                    </Row>
                </Modal.Footer>]
        }

        if(this.state.saved){
            saved = <Alert  variant="success">{Translation.get(12655 , 'Your information has been updated')}</Alert>;
        }

        return <div style={{padding:"20px"}}>
            {popup} 
            <Card body>
                <Row>
                    <Col><p>We offer 4 different CEFR English Tests:</p></Col>
                </Row>
                <Row><Col>
                <ol type = "1">
                    <li>English Proficiency Test A1 to B2</li>
                    <li>Developing - CEFR A1</li>
                    <li>Gaining Confidence - CEFR A2</li>
                    <li>CEFR B1 - B2 </li>
                </ol></Col>
                </Row>
                <Row><Col><p>
                These tests will automatically end if the student does not reach the pass level listed below. For instance, if the student taking the <b>English Proficiency Test</b> only achieves 40% correct answers in the A2 area, the test will end and the student will be given a grade of A1. To pass A2, they need to get 60% or higher as per below.
                </p></Col></Row>
                <Row><Col><p>
                <b>If you would like your students to continue the test and for it not to automatically finish when they don’t achieve the CEFR pass grades, please tick this box</b>
                </p></Col></Row>
                <Row>
                    <Col><p><Checkbox checked={this.state.cefrHasNoDrop} onChange={(event)=>{ 
                            this.setState({cefrHasNoDrop:event.target.checked});
                            this.state.cefrHasNoDrop = event.target.checked;
                            this.saveOnlyCEFR();
                        }} 
                            className="float-left" type="checkbox"  /></p></Col>
                </Row> 
                <Row>
                    <Col><p></p></Col>
                </Row>                
                <Row>
                    <Col md={12}><h4>English Proficiency Test</h4></Col>
                    <table style={{marginLeft:"15px", width:"100%"}} border={1}><tr><td style={{width:"25%",padding:"5px"}}><b>Level</b></td><td style={{padding:"5px"}}><b>Score required in test</b></td></tr>
                    <tr><td style={{padding:"5px"}}>Beginning - CEFR Pre A1</td><td style={{padding:"5px"}}>All Developing - CEFR A1 tasks completed with an average of less than 60%</td></tr>
                    <tr><td style={{padding:"5px"}}>Developing - CEFR A1 </td><td style={{padding:"5px"}}>All Developing - CEFR A1 tasks completed with an average of more than 60% </td></tr>
                    <tr><td style={{padding:"5px"}}>Gaining Confidence - CEFR A2 </td><td style={{padding:"5px"}}>Requirements for Developing - CEFR A1 met, as well as all Gaining Confidence - CEFR A2 tasks completed with an average of more than 60%</td></tr>
                    <tr><td style={{padding:"5px"}}>Extending - CEFR B1 </td><td style={{padding:"5px"}}>Requirements for Gaining Confidence - CEFR A2 met, as well as all Extending - CEFR B1 tasks completed with an average of more than 70% but less than 80% </td></tr>
                    <tr><td style={{padding:"5px"}}>Consolidating - B1+ </td><td style={{padding:"5px"}}>Requirements for Gaining Confidence - CEFR A2 met, as well as all Extending - CEFR B1 tasks completed with an average of more than 80% </td></tr>
                    <tr><td style={{padding:"5px"}}>Approaching Proficiency - CEFR B2 </td><td style={{padding:"5px"}}>Requirements for Consolidating B1+ met, as well as all Approaching Proficiency - CEFR B2 tasks completed with an average of more than 90% </td></tr>
                    </table>
                    <hr></hr>
                    <Col md={12}></Col>
                    <Col md={12}><h4>Developing - CEFR A1</h4></Col>
                    <table style={{marginLeft:"15px", width:"100%"}}border={1}><tr><td style={{width:"25%",padding:"5px"}}><b>Level</b></td><td style={{padding:"5px"}}><b>Score required in test</b></td></tr>
                    <tr><td style={{padding:"5px"}}>Beginning - CEFR Pre A1</td><td style={{padding:"5px"}}>All Developing - CEFR A1 tasks completed with an average of less than 50% </td></tr>
                    <tr><td style={{padding:"5px"}}>Developing - CEFR A1 </td><td style={{padding:"5px"}}>All Developing - CEFR A1 tasks completed with an average of more than 50%</td></tr>
                    </table>
                    <hr></hr>
                    <Col md={12}></Col>
                    <Col md={12}><h4>Gaining Confidence - CEFR A2</h4></Col>
                    <table style={{marginLeft:"15px", width:"100%"}}border={1}><tr><td style={{width:"25%",padding:"5px"}}><b>Level</b></td><td style={{padding:"5px"}}><b>Score required in test</b></td></tr>
                    <tr><td style={{padding:"5px"}}>Beginning - CEFR Pre A1</td><td style={{padding:"5px"}}>All Gaining Confidence - CEFR A2 tasks completed with an average of less than 50% </td></tr>
                    <tr><td style={{padding:"5px"}}>Developing - CEFR A1 </td><td style={{padding:"5px"}}>All Gaining Confidence - CEFR A2 tasks completed with an average of more than 50% but less than 80% </td></tr>
                    <tr><td style={{padding:"5px"}}>Gaining Confidence - CEFR A2 </td><td style={{padding:"5px"}}>All Gaining Confidence - CEFR A2 tasks completed with an average of more than 80% </td></tr>
                    </table>
                    <hr></hr>
                    <Col md={12}></Col>
                    <Col md={12}><h4>CEFR B1 - B2</h4></Col>
                    <table style={{marginLeft:"15px", width:"100%"}}border={1}><tr><td style={{width:"25%"}}><b>Level</b></td><td style={{padding:"5px"}}><b>Score required in test</b></td></tr>
                    <tr><td style={{padding:"5px"}}>Gaining Confidence - CEFR A2 </td><td style={{padding:"5px"}}>All Extending - CEFR B1 tasks completed with an average of less than 60% </td></tr>
                    <tr><td style={{padding:"5px"}}>Extending - CEFR B1 </td><td style={{padding:"5px"}}>All Extending - CEFR B1 tasks completed with an average of more than 80% </td></tr>
                    <tr><td style={{padding:"5px"}}>Consolidating - B1+ </td><td style={{padding:"5px"}}>Requirements for Extending - CEFR B1 met as well as all Consolidating - CEFR B1+ tasks completed with an average of more than 80% </td></tr>
                    <tr><td style={{padding:"5px"}}>Approaching Proficiency - CEFR B2 </td><td style={{padding:"5px"}}>Requirements for Consolidating - CEFR B1+ met as well as all Approaching Proficiency - CEFR B2 tasks completed with an average of more than 80% </td></tr>
                    </table>
                </Row>
            </Card>
        </div>
    }
}